"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenuPane = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../../styles/context");
const use_t_1 = require("use-t");
const MobileMenuHeader_1 = require("./MobileMenuHeader");
const MobileMenuItem_1 = require("./MobileMenuItem");
const styles_1 = require("./styles");
const MobileMenuPane = ({ menu, parent, onPush, onBack, onClose, onSelectArgs, }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    if (menu.pane) {
        return (React.createElement(React.Fragment, null,
            React.createElement(MobileMenuHeader_1.MobileMenuHeader, { title: t(menu.name), parent: parent, onBack: onBack, onClose: onClose }),
            menu.pane()));
    }
    if (menu.raw) {
        return (React.createElement(React.Fragment, null,
            React.createElement(MobileMenuHeader_1.MobileMenuHeader, { title: t(menu.name), parent: parent, onBack: onBack, onClose: onClose }),
            React.createElement("div", { className: (0, styles_1.listClass)(), role: "menu", "aria-label": t(menu.name) }, menu.raw())));
    }
    const children = menu.children ?? [];
    const sepColor = styles.g(0, 0.08);
    const titleColor = styles.g(0.5);
    const renderSeparator = (key) => (React.createElement("div", { key: key, className: (0, styles_1.separatorClass)({ bg: sepColor }), "aria-hidden": "true" }));
    const renderHeading = (item, key) => (React.createElement("div", { key: key, className: (0, styles_1.sectionTitleClass)({ col: titleColor }), role: "presentation" }, item.display?.() ?? t(item.name)));
    const renderItem = (item, key) => (React.createElement(MobileMenuItem_1.MobileMenuItem, { key: key, item: item, onPush: onPush, onSelectArgs: onSelectArgs, onClose: onClose }));
    const nodes = [];
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const id = child.id ?? child.name;
        if (child.sep) {
            nodes.push(renderSeparator(`sep-${id}`));
            continue;
        }
        if (child.heading) {
            nodes.push(renderHeading(child, `heading-${id}`));
            continue;
        }
        if (child.sepBefore && i > 0) {
            nodes.push(renderSeparator(`sepb-${id}`));
        }
        if (child.expand && child.children && child.children.length) {
            nodes.push(React.createElement("div", { key: `title-${id}`, className: (0, styles_1.sectionTitleClass)({ col: titleColor }) }, t(child.name)));
            const inlineCount = Math.min(child.expand, child.children.length);
            for (let j = 0; j < inlineCount; j++) {
                const sub = child.children[j];
                const subId = sub.id ?? sub.name;
                if (sub.sep) {
                    nodes.push(renderSeparator(`${id}-sep-${subId}`));
                    continue;
                }
                if (sub.heading) {
                    nodes.push(renderHeading(sub, `${id}-heading-${subId}`));
                    continue;
                }
                if (sub.sepBefore && j > 0) {
                    nodes.push(renderSeparator(`${id}-sepb-${subId}`));
                }
                nodes.push(renderItem(sub, `${id}-${subId}`));
            }
            if (child.children.length > inlineCount) {
                nodes.push(renderItem({ ...child, onSelect: undefined }, `${id}-more`));
            }
            continue;
        }
        nodes.push(renderItem(child, id));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileMenuHeader_1.MobileMenuHeader, { title: t(menu.name), parent: parent, onBack: onBack, onClose: onClose }),
        React.createElement("div", { className: (0, styles_1.listClass)(), role: "menu", "aria-label": t(menu.name) }, nodes)));
};
exports.MobileMenuPane = MobileMenuPane;
